import { schema } from 'normalizr';
import BorrowerVariableConfigurationSchema from './BorrowerVariableConfigurationSchema';

const BorrowerProfileCardSchema = new schema.Entity('borrowerProfileCards', {
  fields: [BorrowerVariableConfigurationSchema],
});

export default BorrowerProfileCardSchema;
